// extracted by mini-css-extract-plugin
export default {"notifications":"RequestNotifications-module__notifications--tRiba"};